import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, computed, watch } from "vue";
import { useStore } from "@/store";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DatasetSorting',
    emits: ["start-search"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const store = useStore();
        // Initialize selectedSortOption and sortDirection based on store state
        const getInitialSortOption = () => {
            const option = store.selected_sort_option;
            return option.startsWith("-") ? option.substring(1) : option;
        };
        const getInitialSortDirection = () => {
            return store.selected_sort_option.startsWith("-") ? "desc" : "asc";
        };
        const selectedSortOption = ref(getInitialSortOption());
        const sortDirection = ref(getInitialSortDirection());
        const selectedContentsPerPage = ref(store.update_current_Per_Page);
        const sortOptions = [
            "frozen_at",
            "created_at",
            "name",
            "uuid",
            "creator_username",
            "uri",
            "base_uri",
        ];
        const perPageOptions = [
            { text: "10", value: 10 },
            { text: "20", value: 20 },
            { text: "50", value: 50 },
            { text: "100", value: 100 },
        ];
        // Format sortOptions for display in the dropdown
        const formattedOptions = computed(() => {
            return sortOptions.map((option) => ({
                text: option.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
                value: option,
            }));
        });
        // Get the selectedSortValue with the correct prefix based on sortDirection
        const selectedSortValue = computed(() => {
            return sortDirection.value === "asc"
                ? selectedSortOption.value
                : `-${selectedSortOption.value}`;
        });
        // Watch for changes to selectedSortOption
        watch(selectedSortOption, () => {
            store.updateSelectedSortOption(selectedSortValue.value);
            store.updateCurrentPageNumber(1);
            emit("start-search");
        });
        // Toggle the sortDirection and update the store and emit an event
        function toggleSortDirection() {
            sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
            store.updateSelectedSortOption(selectedSortValue.value);
            store.updateCurrentPageNumber(1);
            emit("start-search");
        }
        function updatePerPage(perpage) {
            store.updateCurrentPerPage(perpage);
            store.updateCurrentPageNumber(1);
            emit("start-search");
        }
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, {
                align: "center",
                dense: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                        cols: "auto",
                        class: "d-flex align-center"
                    }, {
                        default: _withCtx(() => [
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-body-2 mr-2" }, "Contents per page:", -1)),
                            _createVNode(_component_v_select, {
                                modelValue: selectedContentsPerPage.value,
                                "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event) => ((selectedContentsPerPage).value = $event)),
                                    updatePerPage
                                ],
                                items: perPageOptions,
                                "item-title": "text",
                                "item-value": "value",
                                density: "compact",
                                variant: "outlined",
                                "hide-details": "",
                                style: { "width": "90px" }
                            }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, {
                        cols: "auto",
                        class: "d-flex align-center"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                                modelValue: selectedSortOption.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedSortOption).value = $event)),
                                items: formattedOptions.value,
                                "item-title": "text",
                                "item-value": "value",
                                density: "compact",
                                variant: "outlined",
                                "hide-details": "",
                                style: { "width": "160px" },
                                class: "mr-2"
                            }, null, 8, ["modelValue", "items"]),
                            _createVNode(_component_v_btn, {
                                color: "primary",
                                size: "small",
                                icon: sortDirection.value === 'asc' ? 'mdi-sort-ascending' : 'mdi-sort-descending',
                                onClick: toggleSortDirection
                            }, null, 8, ["icon"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
